import React from "react"

export function PortfolioAgentIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="35"
      height="35"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9 0.0791016V8.5791V17.0791C7.58908 17.0791 6.25845 16.7353 5.0873 16.127C3.86604 15.4926 2.81819 14.5705 2.03356 13.4506C1.06712 12.0711 0.5 10.3913 0.5 8.5791C0.5 6.26309 1.42627 4.16342 2.92857 2.63034C4.47134 1.05596 6.62159 0.0791016 9 0.0791016Z"
        fill="#00E961"
        stroke="var(--mui-palette-background-default)"
        strokeWidth={1}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 8.5791L16.5196 4.61243C17.1456 5.79661 17.5 7.14646 17.5 8.5791C17.5 10.7237 16.7058 12.6828 15.3954 14.1783C14.6017 15.0841 13.6186 15.8199 12.5079 16.3238C11.4385 16.8089 10.2508 17.0791 9 17.0791V8.5791Z"
        fill="#EF0000"
        stroke="var(--mui-palette-background-default)"
        strokeWidth={1}
      />
      <path
        d="M9 8.5791V0.0791016C12.2618 0.0791016 15.0945 1.91635 16.5196 4.61243L9 8.5791Z"
        fill="#F5CD19"
        stroke="var(--mui-palette-background-default)"
        strokeWidth={1}
      />
    </svg>
  )
}
